import Vue from 'vue'
import Router from 'vue-router'

// Containers
const PrintContainer = () => import('@/containers/PrintContainer')
const LoginContainer = () => import('@/containers/LoginContainer')
const Camera = () => import('@/containers/Camera')
const TheContainer = () => import('@/containers/TheContainer')
const ReportsContainer = () => import('@/containers/ReportsContainer')


const Maintenance = () => import('@/views/maintenance/Index')

const OtherExpenses = () => import('@/views/maintenance/other_expenses/Index')
const OtherExpensesAdd = () => import('@/views/maintenance/other_expenses/Add')
const OtherExpensesUpdate = () => import('@/views/maintenance/other_expenses/Update')
const OtherExpensesAll = () => import('@/views/maintenance/other_expenses/All')

const Materials = () => import('@/views/maintenance/materials/Index')
const MaterialsAdd = () => import('@/views/maintenance/materials/Add')
const MaterialsUpdate = () => import('@/views/maintenance/materials/Update')
const MaterialsAll = () => import('@/views/maintenance/materials/All')

const MaterialUnits = () => import('@/views/maintenance/material_units/Index')
const MaterialUnitsAdd = () => import('@/views/maintenance/material_units/Add')
const MaterialUnitsUpdate = () => import('@/views/maintenance/material_units/Update')
const MaterialUnitsAll = () => import('@/views/maintenance/material_units/All')

const ItemUnits = () => import('@/views/maintenance/item_units/Index')
const ItemUnitsAdd = () => import('@/views/maintenance/item_units/Add')
const ItemUnitsUpdate = () => import('@/views/maintenance/item_units/Update')
const ItemUnitsAll = () => import('@/views/maintenance/item_units/All')

const JobDescriptions = () => import('@/views/maintenance/job_descriptions/Index')
const JobDescriptionsAdd = () => import('@/views/maintenance/job_descriptions/Add')
const JobDescriptionsUpdate = () => import('@/views/maintenance/job_descriptions/Update')
const JobDescriptionsComputation = () => import('@/views/maintenance/job_descriptions/Computation')
const JobDescriptionsAll = () => import('@/views/maintenance/job_descriptions/All')

const MaintenanceDescriptions = () => import('@/views/maintenance/maintenance_descriptions/Index')
const MaintenanceDescriptionsAdd = () => import('@/views/maintenance/maintenance_descriptions/Add')
const MaintenanceDescriptionsUpdate = () => import('@/views/maintenance/maintenance_descriptions/Update')
const MaintenanceDescriptionsAll = () => import('@/views/maintenance/maintenance_descriptions/All')

const Suppliers = () => import('@/views/maintenance/suppliers/Index')
const SuppliersAdd = () => import('@/views/maintenance/suppliers/Add')
const SuppliersUpdate = () => import('@/views/maintenance/suppliers/Update')
const SuppliersAll = () => import('@/views/maintenance/suppliers/All')

const Equipments = () => import('@/views/maintenance/equipments/Index')
const EquipmentsAdd = () => import('@/views/maintenance/equipments/Add')
const EquipmentsUpdate = () => import('@/views/maintenance/equipments/Update')
const EquipmentsAll = () => import('@/views/maintenance/equipments/All')

const Tools = () => import('@/views/maintenance/tools/Index')
const ToolsAdd = () => import('@/views/maintenance/tools/Add')
const ToolsUpdate = () => import('@/views/maintenance/tools/Update')
const ToolsAll = () => import('@/views/maintenance/tools/All')


const ComputationTable = () => import('@/views/maintenance/computation-table/Index')
const ComputationTableAdd = () => import('@/views/maintenance/computation-table/Add')
const ComputationTableUpdate = () => import('@/views/maintenance/computation-table/Update')
const ComputationTableAll = () => import('@/views/maintenance/computation-table/All')

const Manpowers = () => import('@/views/manpowers/Index')
const ManpowersAdd = () => import('@/views/manpowers/Add')
const ManpowersUpdate = () => import('@/views/manpowers/Update')
const ManpowersAll = () => import('@/views/manpowers/All')
const CashAdvance = () => import('@/views/manpowers/cash_advance/Index')
const Payroll = () => import('@/views/manpowers/payroll/Index')
const PrintPayrollDraft = () => import('@/views/manpowers/payroll/PrintDraft')
const PayrollDraft = () => import('@/views/manpowers/payroll/Draft')
const PayrollView = () => import('@/views/manpowers/payroll/View')
const PayrollPrint = () => import('@/views/manpowers/payroll/PrintPayroll')
const PayrollPrintPerItem = () => import('@/views/manpowers/payroll/PrintPayrollPerItem')
const OfficePayroll = () => import('@/views/manpowers/office_payroll/Index')
const OfficePayrollDraft = () => import('@/views/manpowers/office_payroll/Draft')
const OfficePayrollView = () => import('@/views/manpowers/office_payroll/View')
const OfficePayrollPayslip = () => import('@/views/manpowers/office_payroll/Payslip')
const PreferenceCategories = () => import('@/views/manpowers/preference_category/Index')
const PreferenceCategoriesAdd = () => import('@/views/manpowers/preference_category/Add')
const PreferenceCategoriesUpdate = () => import('@/views/manpowers/preference_category/Update')
const PreferenceCategoriesAll = () => import('@/views/manpowers/preference_category/All')

const LeaveApplications = () => import('@/views/manpowers/leave_applications/Index')
const LeaveApplicationsAdd = () => import('@/views/manpowers/leave_applications/Add')
const LeaveApplicationsUpdate = () => import('@/views/manpowers/leave_applications/Update')
const LeaveApplicationsAll = () => import('@/views/manpowers/leave_applications/All')


const Awards = () => import('@/views/manpowers/awards/Index')
const AwardsAdd = () => import('@/views/manpowers/awards/Add')
const AwardsUpdate = () => import('@/views/manpowers/awards/Update')
const AwardsAll = () => import('@/views/manpowers/awards/All')

const Projects = () => import('@/views/projects2/Index')
const ProjectsAdd = () => import('@/views/projects2/Add')
const ProjectsUpdate = () => import('@/views/projects2/Update')
const ProjectsAll = () => import('@/views/projects2/All')
const ProjectDetails = () => import('@/views/projects2/View')
const ProjectLocationDetails = () => import('@/views/projects2/locations/View')
const ProjectLocationStructureDetails = () => import('@/views/projects2/locations/structures/View')
const ProjectLocationStructureItemDetails = () => import('@/views/projects2/locations/structures/items/View')

const Inventories = () => import('@/views/inventories/Index')
const Requests = () => import('@/views/inventories/requests/Index')
const Purchases = () => import('@/views/inventories/purchases/Index')
const Deliveries = () => import('@/views/inventories/deliveries/Index')
const Receivings = () => import('@/views/inventories/receivings/Index')
const Transfers = () => import('@/views/inventories/transfers/Index')
const Issuances = () => import('@/views/inventories/issuances/Index')
const Withdrawals = () => import('@/views/inventories/withdrawals/Index')
const Adjustments = () => import('@/views/inventories/adjustments/Index')

const MaintenanceItems = () => import('@/views/maintenance_items/Index')
const MaintenanceItemsAdd = () => import('@/views/maintenance_items/Add')
const MaintenanceItemsUpdate = () => import('@/views/maintenance_items/Update')
const MaintenanceItemsAll = () => import('@/views/maintenance_items/All')


const Progress = () => import('@/views/projects2/locations/structures/items/reports/Progress')
const BillOfMaterials = () => import('@/views/projects2/locations/structures/items/reports/BillOfMaterials')
const DetailedEstimate = () => import('@/views/projects2/locations/structures/items/reports/DetailedEstimate')
const MaterialInventory = () => import('@/views/projects2/locations/structures/items/reports/MaterialInventory')
const WorkAccomplishmentPerItem = () => import('@/views/projects2/locations/structures/reports/WorkAccomplishment')
const WorkAccomplishmentPerStructure = () => import('@/views/projects2/locations/reports/WorkAccomplishment')
const ProjectBudget = () => import('@/views/projects2/locations/structures/reports/ProjectBudget')
const MonthlyCostForecastPerItem = () => import('@/views/projects2/locations/structures/reports/MonthlyCostForecast')

const UserManagement = () => import('@/views/user-management/Index')
const Users = () => import('@/views/user-management/users/All')
const Roles = () => import('@/views/user-management/roles/All')

const MyAccount = () => import('@/views/MyAccount')


const ImportAttendance = () => import('@/views/import/ImportAttendance')
const ForApproval = () => import('@/views/import/ForApproval')
const ExportSettings = () => import('@/views/export/ExportSettings')


const SiteTimelogAttendance = () => import('@/views/site_timelog/Attendance')
const SiteTimelogForApproval = () => import('@/views/site_timelog/ForApproval')
const OfficeTimelog = () => import('@/views/office_timelog/OfficeTimelog')
const PayrollGroups = () => import('@/views/office_timelog/PayrollGroups')
const OfficeKioskDevices = () => import('@/views/office_timelog/OfficeKioskDevices')
const OfficeTimelogManual = () => import('@/views/manual/OfficeTimelogManual')
const Configuration = () => import('@/views/configuration/Index')
const TimelogHub = () => import('@/views/timelog/Index')
const Holidays = () => import('@/views/maintenance/holidays/Index')
const OtSchedules = () => import('@/views/maintenance/ot_schedules/Index')
const OfficeAttendance = () => import('@/views/office_timelog/OfficeAttendance')
const OfficeForApproval = () => import('@/views/office_timelog/OfficeForApproval')
const OfficeApproved = () => import('@/views/office_timelog/OfficeApproved')
Vue.use(Router);

import {server_details} from '@/config';

export default new Router({
  base: server_details.ROUTER_BASE,
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
      {
          path: '/login',
          name: 'Login',
          component: LoginContainer
      },
      {
          path: '/camera',
          name: 'Camera',
          component: Camera
      },
      {
          // Kiosk: no user login. The page authenticates the machine itself
          // with a device token obtained from an admin-generated one-time code.
          path: '/office-timelog',
          name: 'Office Timelog',
          component: OfficeTimelog,
          meta: { public: true }
      },
      {
          path: '/print',
          name: 'Print',
          component: PrintContainer,
          children: [
              {
                  path: '/print/office-payslip/:id',
                  name: 'Office Payslip',
                  component: OfficePayrollPayslip,
              },
              {
                  path: '/print/manual/office-timelog',
                  name: 'Office Time Log Manual (Print)',
                  component: OfficeTimelogManual,
                  meta: { roles: [1, 2] }
              },
              {
                  path: '/print/payroll/:id',
                  name: 'PayrollPrint',
                  component:PayrollPrint,
              },
              {
                  path: '/print/payroll-per-item/:id',
                  name: 'PayrollPrintPerItem',
                  component:PayrollPrintPerItem,
              },
              {
                  path: '/print/payroll-per-item/:id',
                  name: 'PayrollPrintPerItem',
                  component:PayrollPrintPerItem,
              },
              {
                  path: '/print/ot-nd-computation/:id',
                  name: 'Job Description OT and ND Computation',
                  component: JobDescriptionsComputation
              },
              {
                  path: '/print/payroll-draft/:payroll_type/:project_id/:date_from/:date_to',
                  name: 'Payroll Draft',
                  component: PrintPayrollDraft
              },
          ]
      },
      {
          path: '/reports',
          name: 'Reports',
          component: ReportsContainer,
          children: [
            {
                path: '/reports/progress/:id',
                name: 'Progress',
                component:Progress,
            },
            {
                path: '/reports/bill-of-materials/:id',
                name: 'BillOfMaterials',
                component:BillOfMaterials,
            },
            {
                path: '/reports/detailed-estimate/:id',
                name: 'DetailedEstimate',
                component:DetailedEstimate,
            },
              {
                  path: '/reports/material-inventory/:id',
                  name: 'MaterialInventory',
                  component:MaterialInventory,
              },
              {
                  path: '/reports/work-accomplishment-per-item/:id',
                  name: 'WorkAccomplishmentPerItem',
                  component:WorkAccomplishmentPerItem,
              },
              {
                  path: '/reports/work-accomplishment-per-structure/:id',
                  name: 'WorkAccomplishmentPerStructure',
                  component:WorkAccomplishmentPerStructure,
              },
              {
                  path: '/reports/project-budget/:id',
                  name: 'ProjectBudget',
                  component:ProjectBudget,
              },
              {
                  path: '/reports/monthly-cost-forecast-per-item/:id',
                  name: 'WorkAccomplishmentPerItem',
                  component:MonthlyCostForecastPerItem,
              },
          ]
      },
      {
          path: '/',
          redirect: '/maintenance',
          name: 'Home',
          component: TheContainer,
          children: [
              {
                  path: '/my-account',
                  name: 'My Account',
                  component: MyAccount
              },
              {
                  path: '/manual/office-timelog',
                  name: 'Office Time Log Manual',
                  component: OfficeTimelogManual,
                  meta: { roles: [1, 2] }
              },
              {
                  // All maintenance pages grouped by category.
                  path: '/configuration',
                  name: 'Configuration',
                  component: Configuration
              },
              {
                  // Hub for the Office and Site time log menus.
                  path: '/timelog',
                  name: 'Time Log',
                  component: TimelogHub
              },
              {
                  path: '/user-management',
                  redirect: '/user-management/users',
                  name: 'User Management',
                  component: UserManagement,
                  children: [
                      {
                          path: '/user-management/users',
                          name: 'Users',
                          component: Users
                      },
                      {
                          path: '/user-management/roles',
                          name: 'Roles',
                          component: Roles
                      }
                  ]
              },
            {
                path: '/maintenance',
                redirect: '/configuration',
                name: 'Configuration',
                component:Maintenance,
                children: [
                  {
                    path: '/maintenance/materials',
                    name: 'Materials',
                    component: Materials,
                    redirect: '/maintenance/materials/all',
                    children: [
                        {
                          path: '/maintenance/materials/add',
                          name: 'Add Material',
                          component: MaterialsAdd
                        },
                        {
                          path: '/maintenance/materials/update/:id',
                          name: 'Update Material',
                          component: MaterialsUpdate
                        },
                        {
                          path: '/maintenance/materials/all',
                          name: 'All Materials',
                          component: MaterialsAll
                        }
                      ]
                  },
                  {
                    path: '/maintenance/material-units',
                    name: 'Material Units',
                    component: MaterialUnits,
                    redirect: '/maintenance/material-units/all',
                    children: [
                        {
                          path: '/maintenance/material-units/add',
                          name: 'Add Material Unit',
                          component: MaterialUnitsAdd
                        },
                        {
                          path: '/maintenance/material-units/update/:id',
                          name: 'Update Material Unit',
                          component: MaterialUnitsUpdate
                        },
                        {
                          path: '/maintenance/material-units/all',
                          name: 'All Material Units',
                          component: MaterialUnitsAll
                        }
                      ]
                  },
                  {
                    path: '/maintenance/item-units',
                    name: 'Item Units',
                    component: ItemUnits,
                    redirect: '/maintenance/item-units/all',
                    children: [
                        {
                          path: '/maintenance/item-units/add',
                          name: 'Add Item Unit',
                          component: ItemUnitsAdd
                        },
                        {
                          path: '/maintenance/item-units/update/:id',
                          name: 'Update Item Unit',
                          component: ItemUnitsUpdate
                        },
                        {
                          path: '/maintenance/item-units/all',
                          name: 'All Item Units',
                          component: ItemUnitsAll
                        }
                      ]
                  },
                  {
                    path: '/maintenance/job-descriptions',
                    name: 'Job Descriptions',
                    component: JobDescriptions,
                    redirect: '/maintenance/job-descriptions/all',
                    children: [
                        {
                          path: '/maintenance/job-descriptions/add',
                          name: 'Add Job Description',
                          component: JobDescriptionsAdd
                        },
                        {
                          path: '/maintenance/job-descriptions/update/:id',
                          name: 'Update Job Description',
                          component: JobDescriptionsUpdate
                        },
                        {
                          path: '/maintenance/job-descriptions/all',
                          name: 'All Job Descriptions',
                          component: JobDescriptionsAll
                        }
                      ]
                  },
                  {
                    path: '/maintenance/maintenance-descriptions',
                    name: 'Maintenance Descriptions',
                    component: MaintenanceDescriptions,
                    redirect: '/maintenance/maintenance-descriptions/all',
                    children: [
                        {
                          path: '/maintenance/maintenance-descriptions/add',
                          name: 'Add Maintenance Description',
                          component: MaintenanceDescriptionsAdd
                        },
                        {
                          path: '/maintenance/maintenance-descriptions/update/:id',
                          name: 'Update Maintenance Description',
                          component: MaintenanceDescriptionsUpdate
                        },
                        {
                          path: '/maintenance/maintenance-descriptions/all',
                          name: 'All Maintenance Descriptions',
                          component: MaintenanceDescriptionsAll
                        }
                      ]
                  },
                  {
                    path: '/maintenance/other-expenses',
                    name: 'Other Expense Descriptions',
                    component: OtherExpenses,
                    redirect: '/maintenance/other-expenses/all',
                    children: [
                        {
                          path: '/maintenance/other-expenses/add',
                          name: 'Add Other Expense Description',
                          component: OtherExpensesAdd
                        },
                        {
                          path: '/maintenance/other-expenses/update/:id',
                          name: 'Update Other Expense Description',
                          component: OtherExpensesUpdate
                        },
                        {
                          path: '/maintenance/other-expenses/all',
                          name: 'All Other Expense Descriptions',
                          component: OtherExpensesAll
                        }
                      ]
                  },
                  {
                    path: '/maintenance/suppliers',
                    name: 'Suppliers',
                    component: Suppliers,
                    redirect: '/maintenance/suppliers/all',
                    children: [
                        {
                          path: '/maintenance/suppliers/add',
                          name: 'Add Supplier',
                          component: SuppliersAdd
                        },
                        {
                          path: '/maintenance/suppliers/update/:id',
                          name: 'Update Supplier',
                          component: SuppliersUpdate
                        },
                        {
                          path: '/maintenance/suppliers/all',
                          name: 'All Suppliers',
                          component: SuppliersAll
                        }
                      ]
                  },
                  {
                    path: '/maintenance/equipments',
                    name: 'Equipments',
                    component: Equipments,
                    redirect: '/maintenance/equipments/all',
                    children: [
                        {
                          path: '/maintenance/equipments/add',
                          name: 'Add Equipment',
                          component: EquipmentsAdd
                        },
                        {
                          path: '/maintenance/equipments/update/:id',
                          name: 'Update Equipment',
                          component: EquipmentsUpdate
                        },
                        {
                          path: '/maintenance/equipments/all',
                          name: 'All Equipments',
                          component: EquipmentsAll
                        }
                      ]
                  },
                    {
                        path: '/maintenance/tools',
                        name: 'Tools',
                        component: Tools,
                        redirect: '/maintenance/tools/all',
                        children: [
                            {
                                path: '/maintenance/tools/add',
                                name: 'Add Tool',
                                component: ToolsAdd
                            },
                            {
                                path: '/maintenance/tools/update/:id',
                                name: 'Update Tool',
                                component: ToolsUpdate
                            },
                            {
                                path: '/maintenance/tools/all',
                                name: 'All Tools',
                                component: ToolsAll
                            }
                        ]
                    },
                    {
                        path: '/maintenance/payroll-groups',
                        name: 'Payroll Groups & Shifts',
                        component: PayrollGroups,
                        meta: { roles: [1, 2] }
                    },
                    {
                        path: '/maintenance/office-kiosk',
                        name: 'Kiosk Devices',
                        component: OfficeKioskDevices,
                        meta: { roles: [1, 2] }
                    },
                    {
                        path: '/maintenance/holidays',
                        name: 'Holidays',
                        component: Holidays,
                        meta: { roles: [1, 2] }
                    },
                    {
                        path: '/maintenance/ot-schedules',
                        name: 'Scheduled OT Permission',
                        component: OtSchedules,
                        meta: { roles: [1, 2] }
                    },
                    {
                        path: '/maintenance/computation-table',
                        name: 'Computation Table',
                        component: ComputationTable,
                        redirect: '/maintenance/computation-table/all',
                        children: [
                            {
                                path: '/maintenance/computation-table/add',
                                name: 'Add Computation Table',
                                component: ComputationTableAdd
                            },
                            {
                                path: '/maintenance/computation-table/update/:id',
                                name: 'Update Computation Table',
                                component: ComputationTableUpdate
                            },
                            {
                                path: '/maintenance/computation-table/all',
                                name: 'All Computation Table',
                                component: ComputationTableAll
                            }
                        ]
                    }
                ]
            },
            {
              path: '/manpowers',
              redirect: '/manpowers/all',
              name: 'Employees',
              component:Manpowers,
              children: [
                {
                  path: '/manpowers/add',
                  name: 'Add Manpower',
                  component: ManpowersAdd
                },
                {
                  path: '/manpowers/update/:id',
                  name: 'Update Manpower',
                  component: ManpowersUpdate
                },
                {
                  path: '/manpowers/all',
                  name: 'All Manpowers',
                  component: ManpowersAll
                },
                {
                  path: '/manpowers/cash-advance',
                  name: 'Cash Advance',
                  component: CashAdvance
                },
                {
                  path: '/manpowers/payroll',
                  name: 'Payroll',
                  component: Payroll
                },
                {
                  path: '/manpowers/payroll/:payroll_type/:project_id/:date_from/:date_to',
                  name: 'Payroll Draft',
                  component: PayrollDraft
                },
                {
                  path: '/manpowers/payroll/:id',
                  name: 'Payroll View',
                  component: PayrollView
                },
                {
                  path: '/manpowers/office-payroll',
                  name: 'Office Payroll',
                  component: OfficePayroll,
                  meta: { roles: [1, 2] }
                },
                {
                  path: '/manpowers/office-payroll-draft/:payroll_group_id/:date_from/:date_to',
                  name: 'Office Payroll Draft',
                  component: OfficePayrollDraft,
                  meta: { roles: [1, 2] }
                },
                {
                  path: '/manpowers/office-payroll/:id',
                  name: 'Office Payroll View',
                  component: OfficePayrollView,
                  meta: { roles: [1, 2] }
                },
              {
                  path: '/manpowers/preference-categories',
                  name: 'Preference Categories',
                  component: PreferenceCategories,
                  redirect: '/manpowers/preference-categories/all',
                  children: [
                      {
                          path: '/manpowers/preference-categories/add',
                          name: 'Add Preference Category',
                          component: PreferenceCategoriesAdd
                      },
                      {
                          path: '/manpowers/preference-categories/update/:id',
                          name: 'Update Preference Category',
                          component: PreferenceCategoriesUpdate
                      },
                      {
                          path: '/manpowers/preference-categories/all',
                          name: 'All Preference Categories',
                          component: PreferenceCategoriesAll
                      }
                  ]
              },
                  {
                      path: '/manpowers/awards',
                      name: 'Awards',
                      component: Awards,
                      redirect: '/manpowers/awards/all',
                      children: [
                          {
                              path: '/manpowers/awards/add',
                              name: 'Add Award',
                              component: AwardsAdd
                          },
                          {
                              path: '/manpowers/awards/update/:id',
                              name: 'Update Award',
                              component: AwardsUpdate
                          },
                          {
                              path: '/manpowers/awards/all',
                              name: 'All Awards',
                              component: AwardsAll
                          }
                      ]
                  },
              {
                  path: '/manpowers/leave-applications',
                  name: 'Leave Applications',
                  component: LeaveApplications,
                  redirect: '/manpowers/leave-applications/all',
                  children: [
                      {
                          path: '/manpowers/leave-applications/add',
                          name: 'Add Leave Application',
                          component: LeaveApplicationsAdd
                      },
                      {
                          path: '/manpowers/leave-applications/update/:id',
                          name: 'Update Leave Application',
                          component: LeaveApplicationsUpdate
                      },
                      {
                          path: '/manpowers/leave-applications/all',
                          name: 'All Leave Applications',
                          component: LeaveApplicationsAll
                      }
                  ]
              }
              ]
            },
            {
              path: '/projects',
              redirect: '/projects/all',
              name: 'Projects',
              component:Projects,
              children: [
                {
                  path: '/projects/add',
                  name: 'Add Project',
                  component: ProjectsAdd
                },
                {
                  path: '/projects/all',
                  name: 'All Projects',
                  component: ProjectsAll
                },
                {
                  path: '/projects/:id',
                  name: 'Update Project',
                  component: ProjectsUpdate,
                  redirect: '/projects/:id',
                  children: [
                    {
                      path: '/projects/:id',
                      component: ProjectDetails
                    },
                    {
                      path: '/projects/:id/:project_location_id',
                      component: ProjectLocationDetails,
                    },
                    {
                      path: '/projects/:id/:project_location_id/:project_location_structure_id',
                      component: ProjectLocationStructureDetails,
                    },
                    {
                      path: '/projects/:id/:project_location_id/:project_location_structure_id/:project_location_structure_item_id',
                      component: ProjectLocationStructureItemDetails, 
                    },
                  ]
                }
              ]
            },
            {
              path: '/inventories',
              redirect: '/inventories/requests',
              name: 'Inventories',
              component:Inventories,
              children: [
                {
                  path: '/inventories/requests',
                  name: 'Requests',
                  component: Requests
                },
                {
                  path: '/inventories/purchases',
                  name: 'Purchases',
                  component: Purchases
                },
                {
                  path: '/inventories/deliveries',
                  name: 'Deliveries',
                  component: Deliveries
                },
                {
                  path: '/inventories/receivings',
                  name: 'Receivings',
                  component: Receivings
                },
                {
                  path: '/inventories/transfers',
                  name: 'Transfers',
                  component: Transfers
                },
                  {
                      path: '/inventories/issuances',
                      name: 'Issuances',
                      component: Issuances
                  },
                  {
                      path: '/inventories/withdrawals',
                      name: 'Withdrawals',
                      component: Withdrawals
                  },
                  {
                      path: '/inventories/adjustments',
                      name: 'Adjustments',
                      component: Adjustments
                  },
              ]
            },
            {
              path: '/maintenance-items',
              redirect: '/maintenance-items/all',
              name: 'Maintenance Items',
              component:MaintenanceItems,
              children: [
                {
                  path: '/maintenance-items/add',
                  name: 'Add Maintenance Item',
                  component: MaintenanceItemsAdd
                },
                {
                  path: '/maintenance-items/update/:id',
                  name: 'Update Maintenance Item',
                  component: MaintenanceItemsUpdate
                },
                {
                  path: '/maintenance-items/all',
                  name: 'All Maintenance Items',
                  component: MaintenanceItemsAll
                }
              ]
            },

              {
                  path: '/import-attendance',
                  name: 'Import Attendance',
                  component: ImportAttendance
              },

              {
                  path: '/for-approval',
                  name: 'Attendance For Approval',
                  component: ForApproval
              },
              {
                  path: '/export-settings',
                  name: 'Export Settings',
                  component: ExportSettings
              },
              {
                  path: '/site-timelog-attendance',
                  name: 'Site Attendance',
                  component: SiteTimelogAttendance
              },
              {
                  path: '/site-timelog-for-approval',
                  name: 'Site Timelog For Approval',
                  component: SiteTimelogForApproval
              },
              {
                  path: '/office-timelog-attendance',
                  name: 'Office Attendance',
                  component: OfficeAttendance,
                  meta: { roles: [1, 2] }
              },
              {
                  path: '/office-timelog-for-approval',
                  name: 'Office Timelog For Approval',
                  component: OfficeForApproval,
                  meta: { roles: [1, 2] }
              },
              {
                  path: '/office-timelog-approved',
                  name: 'Office Timelog Approved',
                  component: OfficeApproved,
                  meta: { roles: [1, 2] }
              },
          ]
      },


  ]
}

